import { useQuery } from '@tanstack/react-query';
import { IntegrationResponse } from '../../../types/Integration';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export type UseGetGoogleCalendarsProps = {
  enabled?: boolean;
};

export const fetchOrganizationIntegrations = async () => {
  const response = await CustomAxios.get<IntegrationResponse>(`integrations`);
  const { data } = response;
  return data;
};

export function useGetOrganizationIntegrations({ enabled = true }: UseGetGoogleCalendarsProps) {
  const queryKey: any = [queryKeys.organizationIntegrations];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: fetchOrganizationIntegrations,
  });
  return query;
}
